import { Component, Input, OnDestroy } from '@angular/core';
import { OwnerOption } from '@app/sharedModule/components/batch-owner/config';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FulfillService } from '../../fulfill.service';

@Component({
  selector: 'fulfill-batch-list-delivery-ready',
  templateUrl: './fulfill-batch-list-delivery-ready.component.html',
  styleUrls: ['./fulfill-batch-list-delivery-ready.component.scss'],
  standalone: false,
})
export class FulfillBatchListDeliveryReadyComponent implements OnDestroy {
  private destroy$ = new Subject();

  @Input() batches;
  @Input() columns;
  @Input() ownerList: OwnerOption[];
  filterText;

  constructor(private fulfillService: FulfillService) {
    this.fulfillService.onHasFilter
      .pipe(takeUntil(this.destroy$))
      .subscribe((filterText) => (this.filterText = filterText));
  }

  trackByFn(index, batch) {
    return batch.id;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
